import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import styles from './preference-card.module.scss'

type PreferenceCardProps = {
  title: string
  description: string
  children: React.ReactNode
}

const PreferenceCard = ({
  title,
  description,
  children,
}: PreferenceCardProps) => (
  <Card raised className={styles.card}>
    <div className={styles.cardHeader}>
      <Heading type="h4">{title}</Heading>
      <Paragraph size="small" weight="book" className={styles.hint}>
        {description}
      </Paragraph>
    </div>

    <div className={styles.cardBody}>{children}</div>
  </Card>
)

export default PreferenceCard
